<template>
    <div class="homes" v-loading="loading">
        <div class="banners">
            <banners ref="banners" @handle_lvshi_add="handle_lvshi_add"></banners>
        </div>
        <div class="case_reviews_box">
            <case_reviews ref="case_reviews"></case_reviews>
           
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="6" ></hd_banner>
        </div>
        <div class="dharma_realm_box">
            <dharma ref="dharma"></dharma>
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="7"></hd_banner>
        </div>
        <div class="corporate_legal_affairs">
            <corporate_legal_affairs ref="corporate_legal_affairs"></corporate_legal_affairs>
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="8"></hd_banner>
        </div>
        <div class="lawyer_box">
            <lawyer_box ref="lawyer_box"  @handle_lvshi_add="handle_lvshi_add"></lawyer_box>
        </div>
        <div class="hd_banner">
            <hd_banner ref="hd_banner" :id="9"></hd_banner>
        </div>
        <div class="office_box">
            <office_box ref="office_box" @handle_lvsuo_add="handle_lvsuo_add"></office_box>
        </div>
        <agreement ref="agreement"  @handle_end="handle_end"></agreement>
        <lvshi_add ref="lvshi_add"  @handle_end="handle_end"></lvshi_add>
        
        
    </div>
</template>
<script>
import { mapState} from 'vuex'
import banners from '@/components/index_home/banner.vue'//顶部banner
import case_reviews from '@/components/index_home/case_reviews.vue'//裁判点评
import dharma from '@/components/index_home/dharma.vue'//法界热点
import hd_banner from '@/components/index_home/hd_banner.vue'//活动图片
import corporate_legal_affairs from '@/components/index_home/corporate_legal_affairs.vue'//企业法务
import lawyer_box from '@/components/index_home/lawyer_box.vue'//进住律师
import office_box from '@/components/index_home/office_box.vue'//推荐事务所

import lvshi_add from '@/components/index_home/lvshi_add.vue'//入住律师
// import lvshi_add from '@/components/index_home/lvshi_add.vue'//入住律师

export default {
    components: {
        banners,
        case_reviews,
        dharma,
        hd_banner,
        corporate_legal_affairs,
        lawyer_box,
        office_box,
        lvshi_add

    },
    name: "homes",
    data() {
        return {
            loading: false,
           
        }
    },
    computed: {
        ...mapState(['vuex_user', 'vuex_unread_number'])
    },
    watch: {

    },
    created() {
        // this.$refs.agreement.handle_open()

    },
    mounted(){
        //临时调取
        // this.$refs.agreement.handle_open()
    },
    methods: {
        //同意回调
        handle_end(){},
        // 律师入住回调
        handle_lvshi_add(){
            console.log('123123')
            this.$refs.lvshi_add.handle_open()
        },
        //律所入住回调
        handle_lvsuo_add(){
            this.$router.push({
                path:'/law_firms_add',
            })
        },



    },

}
</script>
<style scoped lang="less">
.homes {
    padding-bottom: 100px


}
</style>